import { ButtonHTMLAttributes } from 'react'
import classNames from 'classnames'
import styles from './buttonBase.module.scss'

type ButtonSize = 'large' | 'small'
type ButtonTextSize = 'large' | 'small'
type ButtonFullWidth = 'always' | 'never' | 'inherit'
type ButtonType = 'button' | 'submit' | 'reset' | undefined
export type ButtonClasses = string | Array<string> | Record<string, boolean>

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement>

export type ButtonBaseFields = {
  children: React.ReactNode
  classes?: ButtonClasses
  size?: ButtonSize
  textSize?: ButtonTextSize
  fullWidth?: ButtonFullWidth
  disabled?: boolean
}

export type ButtonBaseProps = ButtonBaseFields & {
  type?: ButtonType
} & ButtonProps

const ButtonBase = ({
  type = 'button',
  classes,
  children,
  size = 'large',
  textSize,
  fullWidth,
  disabled = false,
  ...props
}: ButtonBaseProps) => {
  const buttonClasses = classNames(
    styles.button,
    styles[size],
    styles[`textSize_${textSize || size}`],
    classes,
    {
      [styles.alwaysFullWidth]: fullWidth === 'always',
      [styles.neverFullWidth]: fullWidth === 'never',
      [styles.inherit]: fullWidth === 'inherit'
    }
  )

  return (
    <button
      {...props}
      className={buttonClasses}
      type={type}
      disabled={disabled}
    >
      {children}
    </button>
  )
}

export default ButtonBase
